var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"bem",rawName:"v-bem"}]},[_c('div',{directives:[{name:"bem",rawName:"v-bem:badge",value:(( _obj = {}, _obj[("acc-" + _vm.color)] = _vm.color !== null, _obj )),expression:"{ [`acc-${color}`]: color !== null }",arg:"badge"}]}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }